import apiClient from './client';
import { Trip, PaginatedResponse } from '../types';

export interface TripPaginationParams {
  pageNo?: number;
  pageSize?: number;
}

export const tripService = {
  // Get all trips (admin) - non-paginated
  getAllTrips: async (): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>('/trips/all', {
      params: {
        type: 'admin',
      },
    });
    return response.data;
  },

  // Get paginated trips (admin)
  getPaginatedTrips: async (params?: TripPaginationParams): Promise<PaginatedResponse<Trip>> => {
    const response = await apiClient.get<PaginatedResponse<Trip>>('/trips/all', {
      params: {
        pageNo: params?.pageNo || 1,
        pageSize: params?.pageSize || 20,
        type: 'admin',
      },
    });
    return response.data;
  },

  // Get all user trips
  getUserTrips: async (): Promise<Trip[]> => {
    const response = await apiClient.get<Trip[]>('/trips/users');
    return response.data;
  },

  // Get trip by ID
  getTripById: async (tripId: string): Promise<Trip> => {
    const response = await apiClient.get<Trip>(`/trips/${tripId}`);
    return response.data;
  },

  // Create trip
  createTrip: async (trip: Partial<Trip>): Promise<Trip> => {
    const response = await apiClient.post<Trip>('/trips', trip);
    return response.data;
  },

  // Update trip
  updateTrip: async (tripId: string, trip: Partial<Trip>): Promise<Trip> => {
    const response = await apiClient.put<Trip>(`/trips/${tripId}`, trip);
    return response.data;
  },

  // Upload trip image
  uploadTripImage: async (tripId: string, file: File): Promise<{ url: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<{ url: string }>(`/trips/${tripId}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Soft delete trip (Inactivate/Activate toggle)
  deleteTrip: async (tripId: string): Promise<void> => {
    await apiClient.post(`/trips/${tripId}/inactive`);
  },

  // Inactivate/Activate trip (toggle)
  inactivateTrip: async (tripId: string): Promise<void> => {
    await apiClient.post(`/trips/${tripId}/inactive`);
  },

  // Get active trip with schedule
  getActiveTripWithSchedule: async (date: string): Promise<any> => {
    const response = await apiClient.get(`/trips/active`, { params: { date } });
    return response.data;
  },
};
